<template lang="pug" >
div.kpidataCoupon
  button(v-for="(kpi, index) in listKpis"
    :value="kpi"
    :key="index"
    @click="selectKpi(kpi.type)" :class="selected === kpi.type ? 'activeC' : 'kpi-cardsC'")
    kpi-card(:ammount='kpi.ammount' :title='kpi.title' :color='kpi.color' :percentage='kpi.percentage')
</template>

<script>
import KpiCard from '@/components/loyalty/Coupons/KpiCard'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'KpiCardsCoupons',
  props: {
    params: {
      require: true
    },
    tipCons: {
      required: true
    },
    appProgram: {
      required: true
    }
  },
  components: { 'kpi-card': KpiCard },
  data () {
    return {
      listKpis: [
        {
          ammount: ('0'),
          title: this.$t('loyalty.totalCoupon'),
          percentage: 0,
          type: 'T',
          color: null
        },
        {
          ammount: ('0'),
          title: this.$t('loyalty.couponsUsed'),
          percentage: 0,
          type: 'U',
          color: '#36B348'
        },
        {
          ammount: ('0'),
          title: this.$t('loyalty.couponsUnused'),
          percentage: 0,
          type: 'N',
          color: '#FFA617'
        }
      ],
      selected: null
    }
  },
  computed: {
    ...mapGetters({
      getLang: 'getLang',
      isReloadCouponsCount: 'isReloadCouponsCount'
    })
  },
  async mounted () {
    this.getAmountsAndPercentages()
  },
  methods: {
    ...mapActions(['getCouponCount', 'setReloadCoupons', 'setReloadCouponsCount']),
    selectKpi (object, callService) {
      this.selected = object
      this.$emit('type-coupon', { tipCons: object, refresh: callService })
    },
    async getAmountsAndPercentages () {
      this.getCouponCount(this.params).then(responseCoupon => {
        // console.log('getCouponCount params responseCoupon', this.params, responseCoupon)
        this.listKpis[0].ammount = String(responseCoupon.registros.totalcupones)
        this.listKpis[1].ammount = String(responseCoupon.registros.totcuputiliz)
        this.listKpis[2].ammount = String(responseCoupon.registros.totacupnoutil)
        if (responseCoupon.registros.totalcupones !== 0) {
          this.listKpis[1].percentage = parseFloat((responseCoupon.registros.totcuputiliz / responseCoupon.registros.totalcupones * 100).toFixed(2))
          this.listKpis[2].percentage = parseFloat((responseCoupon.registros.totacupnoutil / responseCoupon.registros.totalcupones * 100).toFixed(2))
        } else {
          this.listKpis[1].percentage = parseFloat('0')
          this.listKpis[2].percentage = parseFloat('0')
        }
        this.selectKpi(this.tipCons ? this.tipCons : this.listKpis[0].type, true)
        this.setReloadCouponsCount(false)
        this.setReloadCoupons(true)
      }).catch(err => {
        console.log('getCouponCount responseCoupon', err)
      })
    }
  },
  watch: {
    isReloadCouponsCount (newVal, oldVal) {
      console.log('isReloadCouponsCount', newVal, oldVal)
      if (newVal === true) {
        this.getAmountsAndPercentages()
      }
    },
    async getLang () {
      this.listKpis[0].title = this.$t('loyalty.totalCoupon')
      this.listKpis[1].title = this.$t('loyalty.couponsUsed')
      this.listKpis[2].title = this.$t('loyalty.couponsUnused')
    },
    async appProgram (newData) {
      if (newData) {
        this.getAmountsAndPercentages()
      }
    }
  }
}
</script>

<style lang="scss">
</style>
